import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
    selector: 'formly-field-file',
    template: `
   <input type="file" [formlyAttributes]="field">
   <sup *ngIf="to.required" style="color:red;">*</sup>
  `,
    imports: [FormsModule, ReactiveFormsModule, FormlyModule, NgIf]
})
export class FormlyFieldFile extends FieldType {}
